import { Box } from "@cjdev-internal/visual-stack-x/Box";
import { Text } from "@cjdev-internal/visual-stack-x/Text";
import Case from "case";
import { NULL_STATE_METRIC_PLACEHOLDER } from "constants/metrics";
import { useIntl } from "hooks";
import globalMessages from "messages/globalMessages";
import * as R from "ramda";
import React from "react";
import { formatMetricNumber } from "utils/ciqUtils";
import "../styles.css";

export const NumericMetric = ({ name, value }) => {
  const intl = useIntl();
  return (
    <Box
      align="center"
      className="social-stat"
      data-testid={name}
      direction="column"
      gap="xs"
      key={name}
    >
      <Text weight="medium" size={18}>
        {R.isNil(value)
          ? NULL_STATE_METRIC_PLACEHOLDER
          : formatMetricNumber(value)}
      </Text>
      <Text size={12} className="social-stat-center">
        {globalMessages[name]
          ? Case.capital(intl.formatMessage(globalMessages[name]))
          : name}
      </Text>
    </Box>
  );
};
